/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_P2dInputs */

const en_mk_sol_startup_p2d = /** @type {(inputs: Mk_Sol_Startup_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reason a decision was made six weeks ago is written down nowhere, so the same argument comes back.`)
};

const id_mk_sol_startup_p2d = /** @type {(inputs: Mk_Sol_Startup_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alasan sebuah keputusan diambil enam minggu lalu tidak tertulis di mana pun, jadi perdebatan yang sama berulang.`)
};

/**
* | output |
* | --- |
* | "The reason a decision was made six weeks ago is written down nowhere, so the same argument comes back." |
*
* @param {Mk_Sol_Startup_P2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_p2d = /** @type {((inputs?: Mk_Sol_Startup_P2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_P2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_p2d(inputs)
	return en_mk_sol_startup_p2d(inputs)
});